export const agencyAgents = {
  'repupgrade-ai': {
    inputs: 'Available reviews, ratings, business context, feedback, and visibility information. Your agency supplies the client’s goals and judgment.',
    approval: 'Your agency checks the interpretation and chooses the next action. Every business plan can see how the business appears; Local Dominate Complete runs the full strategy.',
    steps: [['Ask a useful question', 'Start with the client’s feedback, context, and the decision you need to make.'], ['Understand the pattern', 'Look at repeated praise, questions, friction, and the information available to support the answer.'], ['Choose the next action', 'Use that direction for Ruby’s replies, Mabel’s articles, or Annie’s posts. Your agency approves the work.']],
    questions: ['What do customers value most about this business?', 'Which concerns deserve attention first?', 'What should Ruby consider in this reply?', 'What questions could Mabel answer in an article?', 'Which customer theme could Annie carry into a social post?', 'What should we focus on next?'],

    name: 'RepUpgrade.ai',
    role: 'Interpretation & Recommendation',
    icon: 'Brain',
    headline: 'Ask your reputation what matters. Decide what comes next.',
    description: 'Ask questions about available reviews, ratings, feedback, and visibility signals in plain language. RepUpgrade.ai helps your agency understand the patterns and choose useful next actions for Ruby, Mabel, and Annie.',
    packaging: 'Package strategy, priorities, and coordinated next actions instead of adding another disconnected dashboard.',
    outputs: [
      'Reputation-pattern interpretation',
      'Priority and risk summaries',
      'Content and response recommendations',
      'Next-action guidance for agency review',
    ],
  },
  ruby: {
    inputs: 'The customer’s review, relevant business context, and the client’s approved voice. Sensitive issues may require the client’s direct involvement.',
    approval: 'Your agency or client checks the reply before supported publication. Replies are paced at no more than five per day, within the selected plan’s allowance.',
    steps: [['Read what mattered', 'Look at the customer’s actual words and the context behind their experience.'], ['Prepare a thoughtful reply', 'Ruby helps draft a response in the client’s voice, with attention to praise, concerns, and tone.'], ['Review and respond', 'Check accuracy, handle sensitive issues with the client, and approve the response.']],

    name: 'Ruby Replies',
    role: 'Review Reply Assistant',
    icon: 'MessageCircle',
    headline: 'Show customers you heard what mattered.',
    description: 'Ruby prepares brand-aligned review-reply drafts that the agency or client can review, edit, approve, and publish through supported workflows.',
    packaging: 'Build an agency-led response rhythm around tone, context, escalation, and approval rather than selling an isolated writing tool.',
    outputs: [
      'Brand-aligned reply drafts',
      'Sentiment-aware response options',
      'Escalation cues for sensitive reviews',
      'Human-reviewed response workflows',
    ],
  },
  annie: {
    inputs: 'Verified customer feedback, approved article themes, business context, and the client’s social voice and connected accounts.',
    approval: 'Your agency checks the message, facts, and channel before supported publishing. Local Dominate Complete includes a social post every three days; other paid plans have their own monthly allowances.',
    steps: [['Choose a story worth sharing', 'Start with something customers value or a useful point from the client’s content.'], ['Shape it for social', 'Annie helps turn that idea into a post that fits the client’s voice and the intended channel.'], ['Approve and share', 'Check claims and permissions, then use the publishing setup available for the client.']],

    name: 'Annie Amplifies',
    role: 'Social Post Assistant',
    icon: 'Share2',
    headline: 'Help customer praise travel beyond the review.',
    description: 'Annie turns verified customer praise into social-post drafts for agency review, editing, approval, and publishing.',
    packaging: 'Package social-proof drafting as part of a coordinated reputation rhythm while the agency retains strategy and publishing responsibility.',
    outputs: [
      'Social-proof post drafts',
      'Channel-aware copy options',
      'Review-to-content concepts',
      'Human review and approval checkpoints',
    ],
  },
  mabel: {
    inputs: 'Customer questions and review themes, the client’s services and expertise, and an approved brand voice.',
    approval: 'Your agency or client checks the facts, usefulness, and voice before supported publishing. Local Dominate Complete includes a blog with a cover image every three days; other paid plans have their own monthly allowances.',
    steps: [['Find the question', 'Start with what customers praise, ask about, or need help understanding.'], ['Develop a useful article', 'Mabel helps turn the theme into an article or FAQ draft. Bring the client’s expertise into the details.'], ['Edit and publish', 'Check accuracy and voice, add the relevant context, and approve the finished work.']],

    name: 'Mabel Writes',
    role: 'Website Article Assistant',
    icon: 'FileText',
    headline: 'Write about what your clients’ customers actually care about.',
    description: 'Mabel turns review themes into article, FAQ, and service-content drafts for human editing, approval, and publishing.',
    packaging: 'Use real customer language to support useful content planning without replacing the agency’s editorial judgment or publishing responsibility.',
    outputs: [
      'Website-article drafts',
      'FAQ and service-page ideas',
      'Customer-language themes',
      'Human-reviewed content workflows',
    ],
  },
};

export function getAgencyAgent(slug) {
  return Object.prototype.hasOwnProperty.call(agencyAgents, slug) ? agencyAgents[slug] : null;
}